// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3PWrB","vLegacy":"SelectSecondary_vLegacy__a_4WW","error":"SelectSecondary_error__2B44d","disabled":"SelectSecondary_disabled__31lde"};